import "script-loader!underscore/underscore.js";
import "script-loader!jquery/dist/jquery.js";
import "script-loader!backbone/backbone.js";


// WEBPACK FOOTER //
// ./example/scripts/load_bower_components.js